
import { defineComponent } from 'vue'
import { getInsuranceOpenData, InsuranceOpenDto } from '@/api/insurance'
import { hasAppFeature } from '@/api/base'
export default defineComponent({
    name: 'InsurancePlanComponent',
    props: ['nodata', 'withoutClosed'],
    data () {
        return {
            x: 0,
            y: 0,
            tips: '',
            planName: '',
            tipsShow: false,
            data: {} as InsuranceOpenDto[],
            cycleOptions: [
                {
                    key: '月度',
                    value: 'month'
                },
                {
                    key: '季度',
                    value: 'quarter'
                },
                {
                    key: '半年度',
                    value: 'half_year'
                },
                {
                    key: '年度',
                    value: 'year'
                },
                {
                    key: '自定义',
                    value: 'diy'
                }
            ]
        }
    },
    async created () {
        const result = await getInsuranceOpenData({
            withoutClosed: this.withoutClosed
        })
        this.data = result
    },
    methods: {
        hasAppFeature,
        hideLogo (event: Event) {
            const img = event.target as HTMLImageElement
            if (img.parentElement) {
                img.parentElement.style.display = 'none'
            }
        },
        findKeyByValue (value: string) {
            const option = this.cycleOptions.find(option => option.value === value)
            console.log(option, 'option')
            return option ? option.key : null
        },
        handleMouseMove (eventTarget : EventTarget, index : number) {
            if (!hasAppFeature('planTips')) {
                return false
            }
            const element = eventTarget as HTMLElement
            const rect = element.getBoundingClientRect()
            this.tips = this.data[index].plan.tips
            this.planName = this.data[index].plan.name
            this.x = rect.left + 260
            this.y = rect.top - 100
            if (this.tips.length > 0) {
                this.tipsShow = true
            }
        },
        handleMouseLeave () {
            console.log(2)
            this.tipsShow = false
        }
    }
})
